export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '65a7bf3f-6c24-4044-9b64-6c383c083328';
export const MODAL_CLOSE_SEC = 2.5;
